/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const MenuSupportersIcon: FC<CommonIconProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C8.69193 1 6 3.69193 6 7C6 10.3081 8.69193 13 12 13C15.3081 13 18 10.3081 18 7C18 3.69193 15.3081 1 12 1ZM8 7C8 4.79807 9.79807 3 12 3C14.2019 3 16 4.79807 16 7C16 9.20193 14.2019 11 12 11C9.79807 11 8 9.20193 8 7ZM12.0002 14C6.7577 14 2.41016 17.5503 2.41016 22C2.41016 22.5481 2.86209 23 3.41016 23C3.95823 23 4.41016 22.5481 4.41016 22C4.41016 18.7381 7.76221 16 12.0002 16C16.2381 16 19.5901 18.7381 19.5901 22C19.5901 22.5481 20.042 23 20.5901 23C21.1382 23 21.5901 22.5481 21.5901 22C21.5901 17.5504 17.2426 14 12.0002 14Z"
      fill="currentColor"
    />
  </svg>
);
